import React from 'react';

const NotificationBadge = ({ count = 0, className = '' }) => {
  if (!count || count <= 0) return null;

  const displayCount = count > 99 ? '99+' : count;

  return (
    <span className={`notification-badge ${className}`}>
      {displayCount}
    </span>
  );
};

export default NotificationBadge;